import CareerOfferCard from "./CareerOfferCard";

export default CareerOfferCard;
